import './App.css';
import MainRoutes from './Pages/MainRoutes';

function App() {
  return (
    <div className="App">
      <MainRoutes/>
    </div>
  );
}

export default App;

